
export const geoRoutes = [
  {
    path: '/geos',
    meta: { title: 'Geo\'s' },
    name: 'Geo\'s',
    component: () => import('../views/geos/Index.vue')
  }
]
